import React from 'react';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import { ColumnDef, SortingState } from '@tanstack/react-table';
import BaseTanStackTable from '../../../components/BaseTanStackTable';
import { useModal } from '../../../hooks/useModal';
import { TIPO_LABEL, Passivo } from '../../../types/passivos';
import DetailModalPassivos from '../modals/DetailModalPassivos';
import EditModalPassivos from '../modals/EditModalPassivos';

interface TablePassivosProps {
  columns: ColumnDef<Passivo>[];
  data: Passivo[];
  pageCount: number;
  pagination: { pageIndex: number; pageSize: number };
  setPagination: React.Dispatch<React.SetStateAction<{ pageIndex: number; pageSize: number }>>;
  sorting: SortingState;
  setSorting: React.Dispatch<React.SetStateAction<SortingState>>;
  isLoading: boolean;
  globalFilter: string;
  setGlobalFilter: (value: string) => void;
  tipoFilter: string;
  setTipoFilter: (value: string) => void;
}

const TablePassivos: React.FC<TablePassivosProps> = ({
  columns,
  data,
  pageCount,
  pagination,
  setPagination,
  sorting,
  setSorting,
  isLoading,
  globalFilter,
  setGlobalFilter,
  tipoFilter,
  setTipoFilter,
}) => {
  const detailModal = useModal<Passivo>();
  const editModal   = useModal<Passivo>();

  return (
    <>
      <BaseTanStackTable
        columns={columns}
        data={data}
        pageCount={pageCount}
        pagination={pagination}
        setPagination={setPagination}
        sorting={sorting}
        setSorting={setSorting}
        globalFilter={globalFilter}
        setGlobalFilter={setGlobalFilter}
        isLoading={isLoading}
        toolbar={
          <>
            <TextField
              value={globalFilter}
              onChange={(e) => setGlobalFilter(e.target.value)}
              placeholder="Buscar na tabela..."
              variant="outlined"
              size="small"
              style={{ width: '300px' }}
            />
            <FormControl size="small" style={{ minWidth: 200 }}>
              <InputLabel>Tipo</InputLabel>
              <Select value={tipoFilter} onChange={(e) => setTipoFilter(e.target.value)} label="Tipo">
                <MenuItem value="">Todos</MenuItem>
                {Object.entries(TIPO_LABEL).map(([value, label]) => (
                  <MenuItem key={value} value={value}>{label}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </>
        }
        renderActions={(row) => (
          <>
            <VisibilityIcon
              onClick={() => detailModal.open(row)}
              style={{ cursor: 'pointer', marginRight: '10px' }}
            />
            <EditIcon
              onClick={() => editModal.open(row)}
              style={{ cursor: 'pointer' }}
            />
          </>
        )}
      />

      {detailModal.isOpen && (
        <DetailModalPassivos
          isOpen={detailModal.isOpen}
          onRequestClose={detailModal.close}
          rowData={detailModal.item}
        />
      )}
      {editModal.isOpen && (
        <EditModalPassivos
          isOpen={editModal.isOpen}
          onRequestClose={editModal.close}
          rowData={editModal.item}
        />
      )}
    </>
  );
};

export default TablePassivos;
